import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface CardGridProps {
  children: ReactNode;
  className?: string;
}

export function CardGrid({ children, className }: CardGridProps) {
  return (
    <div data-card-grid className={cn("grid grid-cols-1 md:grid-cols-2 gap-5", className)}>{children}</div>
  );
}

interface CardGridItemProps {
  width?: "full" | "half";
  children: ReactNode;
  className?: string;
}

export function CardGridItem({
  width = "half",
  children,
  className,
}: CardGridItemProps) {
  return (
    <div
      className={cn(width === "full" ? "col-span-1 md:col-span-2" : "col-span-1", className)}
    >
      {children}
    </div>
  );
}
